import "./src/global.css";

require("prism-themes/themes/prism-one-dark.css");
